// ReduxCashierCartReducer.js

import CreateCartSlice from "../utils/common/CreateCartSlice";

const cashierCartSlice = CreateCartSlice("cashierCart");

export const {
  setUserRefCode: setCashierUserRefCode,
  addItemToCart: addCashierItemToCart,
  updateItemAddons: updateItemAddons,
  removeItemFromCart: removeCashierItemFromCart,
  increaseItemQuantity: increaseCashierItemQuantity,
  decreaseItemQuantity: decreaseCashierItemQuantity,
  updateItemQuantity: updateCashierItemQuantity,
  updateItemRate: updateCashierItemRate,
  clearCart: clearCashierCart,
} = cashierCartSlice.actions;

export default cashierCartSlice.reducer;
